import { render, staticRenderFns } from "./UserPersonalCardDelete.vue?vue&type=template&id=273b698c&"
import script from "./UserPersonalCardDelete.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports